import React from "react";
import "../styles/hero.css";
import { Link } from "react-router-dom";

import heroPlane from "../assets/images/hero-plane.png";
import heroMob from "../assets/images/hero-mob.png";

import liveReward from "../assets/icons/live-reward.svg";
import verified from "../assets/icons/verified.svg";
import bell from "../assets/icons/bell.svg";
import mango from "../assets/icons/mango.svg";

const Hero = () => {
  return (
    <section
      className="hero-section"
      style={{
        backgroundImage: `url(${heroPlane})`,
      }}
    >
      <div className="container">

        {/* Top Row */}

        <div className="row align-items-center">

          <div className="col-lg-7">

            <h1 className="hero-title">
              Travel more.
              <br />
              Earn more.
              <br />
              <span>Fly smarter.</span>
            </h1>

            <p className="hero-description">
              Earn rewards based on your travel distance
              with Flight Mining and get compensated for
              flight delays with Delay Insurance. The next
              generation of TravelFi, Sky Terminal.
            </p>

          </div>

          <div className="col-lg-5 text-center text-lg-end">

            <img
              src={heroMob}
              alt=""
              className="hero-mobile"
            />

          </div>

        </div>

        {/* Bottom Row */}

        <div className="row align-items-stretch hero-bottom">

          <div className="col-lg-5">

            <div className="hero-cards">

              <div className="hero-card">
                <img
                  src={liveReward}
                  alt=""
                />

                <small className="green">
                  LIVE REWARD
                </small>

                <h4>+1,250</h4>

                <span>MANGO</span>
              </div>

              <div className="hero-card">
                <img
                  src={verified}
                  alt=""
                />

                <small className="blue">
                  DISTANCE VERIFIED
                </small>

                <h4>+15,344</h4>

                <span>km</span>
              </div>

              <div className="hero-card">
                <img
                  src={bell}
                  alt=""
                />

                <small className="red">
                  DELAY DETECTED
                </small>

                <h4>IAD</h4>

                <span>Washington D.C.</span>
              </div>

            </div>

            {/* <button className="hero-btn">
              Join Whitelist
            </button> */}

            <Link
              to="/waitlist"
              className="hero-btn d-flex align-items-center justify-content-center text-decoration-none"
            >
              Join Whitelist
            </Link>

          </div>

          <div className="col-lg-3">

            <div className="reward-card">

              <small>
                DISTANCE VERIFIED
              </small>

              <h2>
                15,344
              </h2>

              <div className="reward-divider"></div>

              <div className="reward-bottom">

                <img
                  src={mango}
                  alt=""
                />

                <span>
                  +1,250 MANGO
                </span>

              </div>

            </div>

          </div>

          <div className="col-lg-4"></div>

        </div>

      </div>
    </section>
  );
};

export default Hero;